module.exports = __webpack_public_path__ + "static/media/15.420bbe1f.svg";